export default "https://legacy.eskolare-development.com/images/aws-ed-start-member.png";